import _ from 'lodash'
import axios from 'axios'; 

window._ = _; 

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// XSRF cookie name must match what the backend writes. Parallel localhost
// devcontainers port-suffix it (xsrf_<APP_PORT>) so they don't clobber each
// other's cookie — see devtools/setup/configure-ports.sh. Three name-sources
// stay in sync: backend config/session.php (SESSION_XSRF_COOKIE), Inertia's
// client in app.js, and this axios default (both read VITE_XSRF_COOKIE). Covers
// direct window.axios POSTs (e.g. the studio workbench); Inertia is separate.
window.axios.defaults.xsrfCookieName = import.meta.env.VITE_XSRF_COOKIE || 'XSRF-TOKEN';


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 *
 * Backed by Laravel Reverb (WebSocket server). Connection details come from
 * the VITE_REVERB_* env vars (see .env.example). The Reverb dev service is
 * managed by devtools/services/reverb.sh.
 */

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

// Reverb is opt-in per environment: only open a WebSocket connection when a key
// is configured (VITE_REVERB_APP_KEY). This keeps environments without a running
// Reverb server (CI, browser tests, Reverb-less deploys) free of connection noise
// — consumers must treat window.Echo as possibly-undefined.
const reverbKey = import.meta.env.VITE_REVERB_APP_KEY;

if (reverbKey) {
    const reverbScheme = import.meta.env.VITE_REVERB_SCHEME ?? 'https';

    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: reverbKey,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: Number(import.meta.env.VITE_REVERB_PORT ?? 80),
        wssPort: Number(import.meta.env.VITE_REVERB_PORT ?? 443),
        forceTLS: reverbScheme === 'https',
        enabledTransports: ['ws', 'wss'],
    });
}
